import BaseValidator from "./Base";

export default class FormatValidator extends BaseValidator {
    private regExp: RegExp;

    constructor(name: string, message: string, regex: string) {
        super(name, message);
        this.regExp = new RegExp(regex);
    }

    isNotValid(value: any): boolean {
        return !this.regExp.test(value);
    }
}
